import * as Sentry from "@sentry/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";

import { AdminApplication } from "./app/AdminApplication";
import { getAdminPublicConfig } from "./config/public-config";
import { initializeAdminObservability } from "./observability";
import "./styles/app.css";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Missing Lafayette admin root element.");

initializeAdminObservability(getAdminPublicConfig());

createRoot(rootElement).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={<main role="alert">The staff console could not be loaded.</main>}
    >
      <BrowserRouter>
        <AdminApplication />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
